// Delivery protection toggle for the cart page and cart drawer.
(function () {
  if (window.__dpInit) return;
  window.__dpInit = true;

  const json = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

  function refreshCart() {
    const drawer = document.querySelector('cart-drawer');
    const onCartPage = !!document.getElementById('main-cart-items');
    if (onCartPage || !drawer || typeof drawer.renderContents !== 'function') {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`)
      .then((r) => r.json())
      .then((sections) => drawer.renderContents({ id: null, sections }));
  }

  function setProtection(variantId, on) {
    const req = on
      ? json(`${window.Shopify.routes.root}cart/add.js`, { items: [{ id: Number(variantId), quantity: 1 }] })
      : json(`${window.Shopify.routes.root}cart/change.js`, { id: String(variantId), quantity: 0 });
    return req.then(refreshCart);
  }

  document.addEventListener('change', (e) => {
    const input = e.target.closest('.dp-toggle__input');
    if (!input) return;
    input.disabled = true;
    setProtection(input.dataset.dpVariant, input.checked).catch(() => {
      input.checked = !input.checked;
      input.disabled = false;
    });
  });

  // Keep it to one per order, and drop it if it's the only thing left in the cart.
  function tidy() {
    const input = document.querySelector('.dp-toggle__input');
    const variantId = Number(input ? input.dataset.dpVariant : window.__dpVariant);
    if (!variantId) return;
    window.__dpVariant = variantId;
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const line = cart.items.find((i) => i.variant_id === variantId);
        if (!line) return;
        const others = cart.item_count - line.quantity;
        if (others === 0) return json(`${window.Shopify.routes.root}cart/change.js`, { id: String(variantId), quantity: 0 }).then(refreshCart);
        if (line.quantity > 1) return json(`${window.Shopify.routes.root}cart/change.js`, { id: String(variantId), quantity: 1 }).then(refreshCart);
      });
  }

  document.addEventListener('DOMContentLoaded', tidy);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(tidy, 300));
  }
})();
